var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"mb-4"},[_c('strong',[_vm._v("El número no posee plan")])]),_c('p',[_vm._v("Ingresa a tu sucursal virtual para seleccionar un plan.")]),_c('a',{staticClass:"btn btn-primary",attrs:{"href":"https://mivirgin.virginmobile.cl/","type":"button"}},[_vm._v(" Ir a sucursal virtual ")])])
}]

export { render, staticRenderFns }